<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18 2C18.585 2 19.0451 2.50003 18.9965 3.08305L18.92 4H21C21.5523 4 22 4.44772 22 5V9C22 11.199 20.2255 12.9836 18.0303 12.9999C17.5483 14.7807 16.4913 16.3691 15 17.5132L14.999 20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21C4 20.4477 4.44772 20 5 20H8.999L9 17.514L8.76695 17.3293C7.40307 16.2089 6.42745 14.6929 5.96903 12.9999C3.84215 12.9832 2.11126 11.3082 2.00515 9.20485L2 9V5C2 4.48716 2.38604 4.06449 2.88338 4.00673L3 4H5.079L5.00345 3.08305C4.95487 2.50003 5.41496 2 6 2H18ZM16.9132 4H7.0868L7.69712 11.3239C7.86096 13.2899 8.9132 15.0736 10.5547 16.1679C10.8329 16.3534 11 16.6656 11 17V20H13V17C13 16.6724 13.1605 16.3655 13.4296 16.1786L13.6474 16.0276C15.1753 14.923 16.1461 13.2051 16.3029 11.3239L16.9132 4ZM5.246 6H4V9C4 9.98906 4.71794 10.8104 5.66111 10.9714L5.246 6ZM20 9V6H18.753L18.3389 10.9714C19.2821 10.8104 20 9.98906 20 9Z"
    fill="currentColor"
  />
</svg>
